export default "__VITE_ASSET__DOZRQu4i__"